import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionTypeListPage } from './manage-transaction-types/pages/transaction-type-list-page/transaction-type-list-page';

const routes: Routes = [
  {
    path: 'ar-billings',
    loadChildren: () =>
      import('./ar-billings/ar-billings.module').then(
        (m) => m.ArBillingsModule,
      ),
  },
  {
    path: 'missing-backup-dashboard',
    loadComponent: () =>
      import(
        './missing-backup-dashboard/missing-backup-dashboard.component'
      ).then((m) => m.MissingBackupDashboardComponent),
    // ToDo: ~~~ add auth guard check here
  },
  {
    path: 'manage-transaction-types',
    component: TransactionTypeListPage,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierDeductionsRoutingModule {}
